import { useEffect, useState } from "react";
import { LINKS } from "../../config/links";

const NAV = [
  { label: "Pain", href: "#problem" },
  { label: "Results", href: "#proof" },
  { label: "Attention", href: "#benchmark" },
  { label: "Systems", href: "#advisor-packages" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a1733]/75 backdrop-blur-2xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 flex items-center justify-between h-20">
        {/* Wordmark */}
        <a
          href="#top"
          data-testid="logo-home-link"
          className="flex items-center gap-3 group"
        >
          <span className="relative inline-flex items-center">
            <span className="h-2 w-2 rounded-full bg-amber-500 pulse-ring" aria-hidden />
          </span>
          <span className="font-display text-2xl sm:text-[28px] tracking-[0.18em] font-light text-white">
            ZIVAE
          </span>
          <span className="hidden sm:inline font-sans-body text-[11px] uppercase tracking-[0.28em] text-amber-400 border-l border-white/10 pl-3 ml-1">
            Marketing
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] uppercase tracking-[0.22em] text-slate-300 hover:text-amber-400 transition-colors duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="flex items-center gap-3">
          <a
            href={LINKS.calendar}
            data-testid="header-cta-book-call"
            className="hidden sm:inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-slate-950 font-semibold px-6 py-3 text-[13px] uppercase tracking-[0.16em] transition-colors duration-300"
          >
            Book Strategy Session
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden>
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </a>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {menuOpen && (
        <div
          data-testid="mobile-menu-panel"
          className="md:hidden border-t border-white/10 bg-[#0a1733]/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setMenuOpen(false)}
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm uppercase tracking-[0.22em] text-slate-200 hover:text-amber-400"
              >
                {n.label}
              </a>
            ))}
            <a
              href={LINKS.calendar}
              onClick={() => setMenuOpen(false)}
              data-testid="mobile-cta-book-call"
              className="mt-2 inline-flex items-center justify-center bg-amber-600 text-slate-950 font-semibold px-6 py-3 text-[13px] uppercase tracking-[0.18em]"
            >
              Book Strategy Session
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
